/**
 * Constants related to scenario planner functionality
 */

// Query keys for React Query cache
export const SCENARIO_PLANNER_QUERY_KEYS = {
  SCENARIO_PLANNERS: 'scenarioPlanners',
  SCENARIO_PLANNER: 'scenarioPlanner',
};

// API endpoints (paths only, base URL is handled in the service)
export const SCENARIO_PLANNER_ENDPOINTS = {
  CREATE_SCENARIO_PLANNER: 'scenario-planner',
  GET_SCENARIO_PLANNERS: 'scenario-planners',
};

// Status values for async operations
export const OPERATION_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

// Default pagination settings
export const DEFAULT_PAGINATION = {
  ITEMS_PER_PAGE: 10,
  DEFAULT_PAGE: 1,
};

export const SCENARIO_PLANNER_METRICS = {
  DEPTH_OF_DISCOUNT: 'dod',
  ANY_PROMO_UNIT_PRICE: 'apup',
};
